<template>
    <div>
        <myHead/>
        <div style="background: #F9F8FD">
            <div class="container-large">
                <div class="text-content" >
                    <h1 style="font-size: 48px;
    font-weight: 700;
    line-height: 56px;line-height:70px;margin-bottom:0px;letter-spacing:5px;">永久一对一客户服务</h1>
                    <p style="margin: 16px 0;font-size:16px;letter-spacing:3px;">这里还有免费补单指导，您可以先看下我们准备的资料<br/>
                    有任何疑问都可以咨询客服哟~</p>
                     <router-link  :to="{path:'/pushTask'}">
                        <a-button    style="width:200px" class="loginBtn">
                            立即试用
                        </a-button>
                    </router-link>
                    
                </div>
                <div class="shot-content">
                <picture>
                    <img src="../assets/index.webp">
                </picture>
                </div>
            </div>
        </div>
        <div class="flushed">
            <div class="main">
                <ol class="list">
                    <li @click="xiazai('https://hlqimgnew.oss-cn-beijing.aliyuncs.com/%E6%B7%98%E5%AE%9D%E8%99%9A%E5%81%87%E4%BA%A4%E6%98%93%E7%A8%BD%E6%9F%A5%E7%BB%B4%E5%BA%A6%E8%A7%A3%E6%9E%90.docx')" class="list-item">
                        <div class="item-content">
                            <figure style="background-color: #EDF7F6">
                                <img  style="width: 100%;height: 100%;"  srcset="https://hlqimgnew.oss-cn-beijing.aliyuncs.com/20200402102936.jpg">
                            </figure>
                            <div class="item-span">
                                <div class="item-text">
                                    <div class="item-title">
                                        淘宝虚假交易稽查纬度
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    
                </ol>
            </div>
        </div>
        <myFooter/>
    </div>
</template>
<script>
import myHead from '../components/myHead'
import myFooter from '../components/myFooter'
import { announcementGetResources } from '@/request.js'

export default {
    components:{myHead,myFooter},
    data() {
        return {
            resourcesList:[],
        };
    },
    methods: {
        xiazai(url){
            window.open(url);
        },
        to(path){
            this.$router.push(path)
        }
    },
    created(){

    },
    mounted() {
        announcementGetResources({},(res)=>{
            this.Resources=res.Result;
        });
    }
};
</script>
<style scoped>
.item-title{
color: #fff;
    font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.item-text{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    min-width: 0;
}
.item-span{
    background: linear-gradient(180deg, transparent 62%, rgba(0,0,0,0.00345888) 63.94%, rgba(0,0,0,0.014204) 65.89%, rgba(0,0,0,0.0326639) 67.83%, rgba(0,0,0,0.0589645) 69.78%, rgba(0,0,0,0.0927099) 71.72%, rgba(0,0,0,0.132754) 73.67%, rgba(0,0,0,0.177076) 75.61%, rgba(0,0,0,0.222924) 77.56%, rgba(0,0,0,0.267246) 79.5%, rgba(0,0,0,0.30729) 81.44%, rgba(0,0,0,0.341035) 83.39%, rgba(0,0,0,0.367336) 85.33%, rgba(0,0,0,0.385796) 87.28%, rgba(0,0,0,0.396541) 89.22%, rgba(0,0,0,0.4) 91.17%);
    border-radius: 8px;
    padding: 20px;
    pointer-events: none;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: end;
    align-items: flex-end;
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    -webkit-transition: opacity 300ms ease;
    transition: opacity 300ms ease;
    opacity: 1;
}
.item-content{
    cursor: pointer;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    padding-bottom: 75%;
    height: 0;
}
.list-item{
    transform: translate3d(0, 0, 0);
    display: list-item;
    text-align: -webkit-match-parent;
    list-style: none;
}
.list{
    display: grid;
    list-style: none;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    grid-gap: 36px;
    position: relative;
    padding-left: 72px;
    padding-right: 72px;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}
.main{
        float: none;
    width: auto;
    max-width: none;
}
.flushed{
    padding-left: 0;
    padding-right: 0;
    padding: 32px 32px 40px;
    width: 100%;
    box-sizing: border-box;
}
.text-content{
    margin-top: 0;
    align-items: flex-start;
    text-align: left;
        display: flex;
            flex-direction: column;
}
.container-large{
     padding-right:5%;
    padding-left:5%;
    height: 480px;
    -ms-flex-direction: row;
    flex-direction: row;
    padding-top: 0;
    padding-bottom: 0;
    -ms-flex-pack: justify;
    justify-content: space-between;
    display: flex;
        align-items: center;
        padding-left: 8%;
    padding-right: 8%;
        box-sizing: border-box;
    width: 100%;
    margin: 0 auto;
}
</style>